export const anatomyModule = {
  id: "anatomy",
  title: "Brain Anatomy",
  sections: [
    {
      type: "text",
      content:
        "The heart is a muscular organ approximately the size of your fist. It consists of four chambers: two atria (upper chambers) and two ventricles (lower chambers).",
      funFact:
        "💡 Fun Fact: Your heart beats about 100,000 times per day, pumping roughly 2,000 gallons of blood!",
      image: "/images/heart/heart-chambers.jpg",
    },
    {
      type: "text",
      content:
        "The right side of the heart receives deoxygenated blood from the body and pumps it to the lungs. The left side receives oxygenated blood from the lungs and pumps it to the rest of the body.",
      image: "/images/heart/blood-flow.jpg",
    },
    {
      type: "flipcard",
      front: "What are the four chambers of the heart?",
      back: "Right atrium, Right ventricle, Left atrium, Left ventricle",
    },
    {
      type: "question",
      text: "How many chambers does the heart have?",
      options: ["2", "3", "4", "5"],
      correct: 2,
      explanation:
        "The heart has 4 chambers: 2 atria (upper) and 2 ventricles (lower).",
    },
    {
      type: "question",
      text: "Which side of the heart pumps blood to the lungs?",
      options: ["Right side", "Left side", "Both sides", "Neither side"],
      correct: 0,
      explanation:
        "The right side of the heart pumps deoxygenated blood to the lungs for oxygenation.",
    },
  ],
};
